/* Sac de Jour — Loox reviews in the theme design (no Loox widget).
   Data: Loox Storefront API (no key; accepted from the store's own domain only).
   Modes: data-mode="product" (reviews of data-product) or data-mode="store" (every review of the store, for the reviews page). */
(() => {
  const API = 'https://storefront-api.loox.io/storefront/v1/store/';
  const rtf = 'RelativeTimeFormat' in Intl ? new Intl.RelativeTimeFormat('fr', { numeric: 'auto' }) : null;
  const nf = (n, d) => Number(n).toLocaleString('fr-FR', d ? { minimumFractionDigits: d, maximumFractionDigits: d } : undefined);

  const el = (tag, cls, txt) => { const n = document.createElement(tag); if (cls) n.className = cls; if (txt != null) n.textContent = txt; return n; };
  const ago = (iso) => {
    const d = new Date(iso); if (isNaN(d)) return '';
    const s = (d - Date.now()) / 1000, a = Math.abs(s);
    const u = [[31536000, 'year'], [2592000, 'month'], [604800, 'week'], [86400, 'day'], [3600, 'hour']];
    for (const [sec, unit] of u) if (a >= sec) return rtf ? rtf.format(Math.round(s / sec), unit) : d.toLocaleDateString('fr-FR');
    return rtf ? rtf.format(0, 'day') : d.toLocaleDateString('fr-FR');
  };
  const stars = (r) => {
    const w = Math.max(0, Math.min(5, Number(r) || 0)) / 5 * 100;
    const svg = '<svg class="icon" viewBox="0 0 15 15"><use href="#i-star"/></svg>'.repeat(5);
    const s = el('span', 'stars'); s.setAttribute('role', 'img'); s.setAttribute('aria-label', `Note ${nf(r, 1)} sur 5`);
    s.innerHTML = `<span class="base">${svg}</span><span class="fill" style="width:${w}%">${svg}</span>`;
    return s;
  };
  const tick = '<svg viewBox="0 0 12 12" aria-hidden="true"><circle cx="6" cy="6" r="6" fill="currentColor"/><path d="M3.4 6.2 5.2 8l3.4-3.6" fill="none" stroke="#fff" stroke-width="1.4"/></svg>';
  const path = (u) => { try { const x = new URL(u, location.origin); return x.pathname; } catch (e) { return ''; } };

  function init(root) {
    const store = root.dataset.store, mode = root.dataset.mode === 'store' ? 'store' : 'product';
    const pid = root.dataset.product, limit = +root.dataset.limit || 6, shop = root.dataset.shop || '';
    const grid = root.querySelector('[data-rv-grid]'), more = root.querySelector('[data-rv-more]');
    const filters = root.querySelector('[data-rv-filters]'), sortSel = root.querySelector('[data-rv-sort]');
    const dlg = root.querySelector('[data-rv-dlg]'), dlgBody = root.querySelector('[data-rv-dlg-body]');
    if (!store || !grid || (mode === 'product' && !pid)) return;
    const base = API + encodeURIComponent(store);
    let page = 1, total = null, filter = '', sort = (sortSel && sortSel.value) || root.dataset.sort || 'featured', loading = false;

    const openMedia = (m) => {
      dlgBody.textContent = '';
      if (m.type === 'video') { const v = el('video'); v.src = m.url; v.controls = true; v.autoplay = true; v.playsInline = true; dlgBody.append(v); }
      else { const i = el('img'); i.src = m.url; i.alt = 'Photo client'; dlgBody.append(i); }
      dlg.showModal ? dlg.showModal() : dlg.setAttribute('open', '');
    };
    dlg && dlg.addEventListener('click', (e) => { if (e.target === dlg || e.target.closest('[data-rv-close]')) { dlgBody.textContent = ''; dlg.close(); } });

    const card = (r) => {
      const a = el('article', 'review');
      const media = (r.media || []).filter(m => m && (m.url || m.thumbnailUrl)).slice(0, 3);
      if (media.length) {
        const ph = el('div', 'review__photos');
        media.forEach((m) => {
          const b = el('button'); b.type = 'button'; b.setAttribute('aria-label', m.type === 'video' ? 'Voir la vidéo' : 'Agrandir la photo');
          if (m.type === 'video') b.dataset.video = '';
          const i = el('img'); i.loading = 'lazy'; i.alt = ''; i.src = m.type === 'video' ? (m.thumbnailUrl || m.url) : (m.thumbnailUrl && m.type !== 'photo' ? m.thumbnailUrl : m.url);
          i.onerror = () => b.remove();
          b.append(i); b.addEventListener('click', () => openMedia(m)); ph.append(b);
        });
        a.append(ph);
      }
      const body = el('div', 'review__body');
      const head = el('div', 'review__head'), au = el('div', 'review__author');
      const name = (r.reviewer && r.reviewer.name) || 'Client';
      au.append(el('span', 'review__avatar', name.trim().charAt(0).toUpperCase()));
      const who = el('div'); who.append(el('p', 'review__name', name));
      au.append(who);
      head.append(au, stars(r.rating)); body.append(head);
      if (r.verified) { const v = el('span', 'review__verified'); v.innerHTML = tick; v.append(' Achat vérifié'); body.append(v); }
      const txt = (r.body || '').trim();
      if (txt) {
        const p = el('p', 'review__text', txt); body.append(p);
        if (txt.length > 320) {
          p.classList.add('is-clamped');
          const rm = el('button', 'review__readmore', 'Lire la suite'); rm.type = 'button';
          rm.addEventListener('click', () => { p.classList.toggle('is-clamped'); rm.textContent = p.classList.contains('is-clamped') ? 'Lire la suite' : 'Réduire'; });
          body.append(rm);
        }
      }
      (r.customQuestions || []).filter(q => q && q.question && q.answer).forEach((q) => {
        const v = el('p', 'review__variant', q.question + ' : '); v.append(el('b', null, q.answer)); body.append(v);
      });
      if (r.reply && r.reply.body) {
        const rp = el('div', 'review__reply'); rp.append(el('b', null, 'Réponse de ' + shop), document.createTextNode(r.reply.body)); body.append(rp);
      }
      // Reviews page: link each review to its product
      if (mode === 'store' && r.product && r.product.name) {
        const href = path(r.product.url);
        const pr = el(href ? 'a' : 'div', 'review__product');
        if (href) pr.href = href;
        if (r.product.imageUrl) { const im = el('img'); im.loading = 'lazy'; im.alt = ''; im.width = 44; im.height = 44; let src = r.product.imageUrl; try { const iu = new URL(src); if (/cdn\.shopify\.com$/.test(iu.hostname)) { iu.searchParams.set('width', '88'); src = iu.href; } } catch (e) {} im.src = src; pr.append(im); }
        const t = el('span'); t.append(el('small', null, 'Avis sur'), el('b', null, r.product.name)); pr.append(t);
        body.append(pr);
      }
      a.append(body);
      return a;
    };

    const url = () => {
      const u = new URL(base + '/product-reviews');
      if (mode === 'product') u.searchParams.set('product_id', pid);
      u.searchParams.set('limit', limit); u.searchParams.set('page', page);
      u.searchParams.set('sort', sort);
      if (/^[1-5]$/.test(filter)) u.searchParams.set('rating', filter);
      if (total != null) u.searchParams.set('total', total);
      return u;
    };

    async function load(reset) {
      if (loading) return; loading = true; more.disabled = true;
      if (reset) { page = 1; total = null; }
      try {
        const res = await fetch(url(), { headers: { Accept: 'application/json' } });
        if (!res.ok) throw new Error('Loox ' + res.status);
        const data = await res.json();
        let list = data.reviews || [];
        if (filter === 'photo') list = list.filter(r => (r.media || []).length);
        if (reset) grid.textContent = '';
        list.forEach(r => grid.append(card(r)));
        const pg = data.pagination || {};
        total = pg.total != null ? pg.total : total;
        more.hidden = !pg.hasMore;
        page += 1;
        // "Avec photos" scans the next pages until something is found
        if (filter === 'photo' && !grid.children.length && pg.hasMore && page < 8) { loading = false; return load(false); }
        if (!grid.children.length) grid.append(el('p', 'sdj-rv__empty', 'Aucun avis pour ce filtre.'));
      } catch (e) {
        console.warn('[sdj-reviews]', e);
        if (reset) { grid.hidden = true; if (filters) filters.hidden = true; }
        more.hidden = true;
      } finally { loading = false; more.disabled = false; }
    }

    async function bottomline() {
      try {
        const res = await fetch(base + '/product-reviews/bottomline' + (mode === 'product' ? '/' + encodeURIComponent(pid) : ''));
        if (!res.ok) return true;
        const b = await res.json();
        if (!b || !b.totalReviews) { if (mode === 'product') { root.hidden = true; return false; } return true; }
        const sc = root.querySelector('[data-rv-score]'), ct = root.querySelector('[data-rv-count]'), st = root.querySelector('[data-rv-stars]');
        if (sc) sc.textContent = nf(b.averageRating, 1);
        if (ct) ct.textContent = nf(b.totalReviews);
        if (st) { st.textContent = ''; st.append(stars(b.averageRating)); }
        const dist = root.querySelector('[data-rv-dist]'), d = b.ratingDistribution || {};
        if (dist) {
          dist.textContent = '';
          [5, 4, 3, 2, 1].forEach((n) => {
            const c = +d[n] || 0, row = el('div'), bar = el('i'), fill = el('b');
            fill.style.width = (b.totalReviews ? c / b.totalReviews * 100 : 0) + '%'; bar.append(fill);
            row.append(el('span', null, n + ' ★'), bar, el('span', null, nf(c))); dist.append(row);
          });
          dist.hidden = false;
        }
        root.classList.add('is-ready');
      } catch (e) { /* summary keeps the server values */ }
      return true;
    }

    if (filters) {
      filters.hidden = false;
      filters.addEventListener('click', (e) => {
        const b = e.target.closest('[data-rv-filter]'); if (!b || loading) return;
        filters.querySelectorAll('[data-rv-filter]').forEach(x => { const on = x === b; x.classList.toggle('is-on', on); x.setAttribute('aria-pressed', on); });
        filter = b.dataset.rvFilter; load(true);
      });
    }
    sortSel && sortSel.addEventListener('change', () => { sort = sortSel.value; load(true); });
    more.addEventListener('click', () => load(false));

    const start = async () => { if (await bottomline()) load(true); };
    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((en) => { if (en.some(x => x.isIntersecting)) { io.disconnect(); start(); } }, { rootMargin: '600px 0px' });
      io.observe(root);
    } else start();
  }

  document.querySelectorAll('[data-sdj-reviews]').forEach(init);
})();
